import { compareDesc, parseISO } from 'date-fns';
import { sort } from 'ramda';
import { useMemo } from 'react';

import { BonusFlipItem } from './components/BonusFlipItem';
import { CompointsBanner } from './components/CompointsBanner';
import { Bonus, BonusStage, Freespin } from '@/api/common';
import { useCommonStore } from '@/store';

import { ScActiveBonuses } from './styled';

export const ActiveBonuses = () => {
  const freespins = useCommonStore.use.freespins();
  const bonuses = useCommonStore.use.bonuses();

  const allBonuses = useMemo(() => {
    if (!bonuses || !freespins) return [];

    const allBonuses: (Bonus | Freespin)[] = [...bonuses, ...freespins];

    const activeBonuses = allBonuses.filter(({ stage }) => {
      return [
        BonusStage.Issued,
        BonusStage.HandleBets,
        BonusStage.Activated,
      ].includes(stage);
    });

    const sortedData = sort(
      (a: Bonus | Freespin, b: Bonus | Freespin) =>
        compareDesc(parseISO(b.createdAt), parseISO(a.createdAt)),
      activeBonuses
    );

    return sortedData.reverse();
  }, [bonuses, freespins]);

  return (
    <ScActiveBonuses>
      <CompointsBanner />
      {allBonuses.length ? (
        <div className="bonus-cards-container">
          {allBonuses.map((bonus) => (
            <BonusFlipItem bonus={bonus} key={bonus.id} />
          ))}
        </div>
      ) : null}
    </ScActiveBonuses>
  );
};
